import { Effect, Option } from 'effect';

import { DEFAULT_TIMEZONE } from '../../../config/clock';

import { decodeTokenEffect, type JwtPayloadT } from '@vs-shop/engine/auth/jwt';

import { getAuthTokenOption } from '@vs-shop/engine/utils/cookies/getAuthToken';

/**
 * Decodes the authentication token from cookies.
 * Returns Option.none() if no token exists or if decoding fails.
 *
 * @returns Effect that resolves to Option<JwtPayloadT>
 */
export const decodeAuthTokenFromCookies = Effect.gen(function* () {
  const tokenOption = yield* getAuthTokenOption;

  return yield* Option.match(tokenOption, {
    onNone: () => Effect.succeed(Option.none<JwtPayloadT>()),
    onSome: (token) =>
      decodeTokenEffect(token, DEFAULT_TIMEZONE).pipe(
        Effect.asSome,
        Effect.orElseSucceed(() => Option.none<JwtPayloadT>())
      ),
  });
});
